import Req from '../../req'
const actions = {
    getUserConfig: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
        }
        Req.node.getUserConfig(data, cb);
    },
    postUserConfig: function (store, []) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
            is_read_guide:true,
        }
        Req.node.postUserConfig(data);
    },

}
export default {
    namespaced: false,
    actions
}